const VGQuiz = {
	valuation: {
		items: {
			title: 'Предмет оценки',
			values: null
		},
		directs: {
			title: 'Направление оценки',
			values: null
		},
		files: {
			title: 'Документы',
			values: null
		},
		users: {
			title: 'Контактные данные',
			values: null
		}
	},

	init: function () {
		let _this = this,
			$pane = document.getElementById('quiz-items');

		if ($pane) {
			let $btn = $pane.querySelector('button[data-next]');

			if ($btn) {
				_this.Fields.isChecked($pane);

				$btn.onclick = function () {
					_this.valuation.items.values = _this.Fields.checkOut($pane);
					_this.Steps.next(this.dataset.next);

					return false;
				}
			}
		}
	},

	Steps: {
		next: function (target) {
			let _this = this,
				$pane = document.getElementById('quiz-' + target),
				isActive = _this.setActive($pane);

			let to = document.getElementById('request').offsetTop;
			window.scrollTo(0, to);

			if (isActive) {
				let $btnNext = $pane.querySelector('button[data-next]'),
					$btnPrev = $pane.querySelector('button[data-prev]'),
					$btnSubmit = $pane.querySelector('button[type=submit]'),
					isType= $pane.dataset.type;

				if ($btnNext) {
					if (isType === 'check') {
						VGQuiz.Fields.isChecked($pane);
					}

					$btnNext.onclick = function () {
						if (isType === 'check') {
							VGQuiz.valuation[target].values = VGQuiz.Fields.checkOut($pane);
						}

						if (isType === 'files') {
							VGQuiz.valuation[target].values = VGQuiz.Fields.filesOut($pane);
						}

						_this.next(this.dataset.next);

						return false;
					}
				}

				if ($btnPrev) {
					$btnPrev.onclick = function () {
						_this.prev(this.dataset.prev);

						return false;
					}
				}

				if ($btnSubmit) {
					$btnSubmit.onclick = function () {
						if (isType === 'text') {
							VGQuiz.valuation[target].values = VGQuiz.Fields.textOut($pane);
						}

						_this.submit($pane);

						return false;
					}
				}
			}
		},

		prev: function (target) {
			return this.setActive(document.getElementById('quiz-' + target))
		},

		submit: function ($pane) {
			let isHasErrors = VGQuiz.Fields.isDataValid($pane);

			if(!isHasErrors) {
				let $form = $('#form-quiz'),
					data = new FormData(document.getElementById('form-quiz'));

				$.ajax({
					url: $form.attr('action'),
					method: $form.attr('method'),
					data: data,
					cache: false,
					contentType: false,
					processData: false,
					beforeSend: function () {
						$form.find('button[type=submit]').attr('disabled', true)
					},
					success: function (data) {
						let obj;

						$form.find('button[type=submit]').attr('disabled', false);

						AlertFormSender.Action.success(data.msg, $form, {});

						yandexMetrika.goal('order');
					},
					error: function (jqXHR, exception) {
						let json = JSON.parse(jqXHR.responseText);
						let msg;

						$form.trigger('submit-error');

						if (json.errors) {
							msg = json.errors[Object.keys(json.errors)[0]][0];
						} else {
							msg = json.message || json.msg;
						}
					}
				});
			}
		},

		setActive: function ($paneActive) {
			let $requestSteps = document.getElementById('quiz'),
				$panes = $requestSteps.querySelectorAll('.tab-quiz-pane');

			if ($panes.length) {
				for (let $pane of $panes) {
					$pane.classList.remove('active');
				}
			}

			if ($paneActive) {
				$paneActive.classList.add('active');

				return true;
			} else {
				return false;
			}
		}
	},

	Fields: {
		checkOut: function ($pane) {
			return [...$pane.querySelectorAll('input[type=checkbox]:checked')];
		},

		isChecked: function ($pane) {
			let _this = this,
				$inputs = $pane.querySelectorAll('input[type=checkbox]'),
				$btn = $pane.querySelector('button[data-next]');

			if($inputs.length) {
				for (let $input of $inputs) {
					$input.onchange = function () {
						let isChecked = !!_this.checkOut($pane).length;

						if (isChecked) {
							$btn.removeAttribute('disabled');
						} else {
							$btn.setAttribute('disabled', 'disabled');
						}
					}
				}
			}
		},

		filesOut: function ($pane) {
			let arr = [];

			let $files = $pane.querySelectorAll('input[type=file]');
			if ($files.length) {
				for (let $file of $files) {
					arr.push($file);
				}
			}

			return arr;
		},

		textOut: function ($pane) {
			let arr = [];

			let $texts = $pane.querySelectorAll('input');
			if ($texts.length) {
				for (let $text of $texts) {
					arr.push($text);
				}
			}

			return arr;
		},

		isDataValid: function ($pane) {
			let $errors = $pane.querySelectorAll('.form-control-error'),
				arr = VGQuiz.valuation.users.values,
				errors = false;

			for (let el of $errors) {
				el.classList.remove('show');
			}

			if (arr.length) {
				for (let el of arr) {
					if (el.value === '' || el.value === 'undefined') {
						errors = true;

						let error = el.closest('div').querySelector('.form-control-error');
						error.classList.add('show');
					}
				}
			} else {
				if ($errors.length) {
					errors = true;

					for (let el of $errors) {
						el.classList.add('show');
					}
				}
			}

			return errors;
		}
	},
};


const $quiz = document.getElementById('quiz');
if ($quiz) {
	VGQuiz.init();
}
